import { FC, Children } from 'react';
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { ExpandMore } from '@mui/icons-material';
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';
import './Hint.scss';

type HintProps = {
	title: string;
	children?: any;
};

const HintGeneric: FC<HintProps> = ({ title, children }) => (
	<div className="hint-generic">
		<Accordion elevation={0}>
			<AccordionSummary expandIcon={<ExpandMore />}>
				<EmojiObjectsOutlinedIcon color="secondary" />
				<span className="title">{title}</span>
			</AccordionSummary>
			<AccordionDetails sx={{ padding: 0 }}>
				{Children.map(children, (child) => (
					<div className="Row">{child}</div>
				))}
			</AccordionDetails>
		</Accordion>
	</div>
);

export default HintGeneric;
